module.exports = __webpack_public_path__ + "static/img/第二十一届.db7037d.png";


//////////////////
// WEBPACK FOOTER
// ./static/20260620/past/第二十一届.png
// module id = Wt2B
// module chunks = 1